import React, { Component } from 'react';
import {Link,browserHistory} from 'react-router';
import {Modal,Button } from 'react-bootstrap';
import $ from 'jquery';
import Web_NotFound from './../Common/Web_NotFound.js';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import { ccAvenue,razorpayForm } from "./../funtions/custom_functions.js";
import {connect} from 'react-redux';
import * as actions from '../../actions';

class Web_Order_Details extends Component{
	constructor(props){
		super(props);
		this.state={}
		this.state={
			total_data:[],
			details:[],
			shipping_address:[],

			items:[],
			aqua_cash:'',
			aqua_cash1:'',
			coupons_amt:'',
			coupons_amt1:'',
			seller_discount:'',
			seller_discount1:'',
			promo_manf_value:'',
			promo_manf_value1:'',
			promo_hatch_value:'',
			promo_hatch_value1:'',
			applied_coupons:[],
			applied_coupons1:'',
			payment_details:[],
			payment_log:[],
			shipment_log:[],
			ship_dlvr_blck:[],
			details_status:false,
			page_error_status:false,
			page_loading:false,

			pay_now_btn:'',
			other_amount_btn:'',
			famount_pay_manufacturer:'',

			other_amount_btn_status: false,
			err_qty_status:false,
			err_qty_msg:'',
			min_val:'',
			max_val:'',
			book_id:'',
			applied_cpns_amt:'',
			confirm_modal:false,
			famount_pay_hatchery:'',

			edit_input_status:false,
			edit_input:'',
			cancel_modal_status:false,
			cancel_reasons:[],
			selected_reason:'',

			rate_flag:'',
			shipping_details:'',
			confirm_btn_show:'',
			transport_mode:'',

			cancel_time:'',
			cancel_reason:'',
			cancel_by:'',
			cancel_success_status:false,
			cancel_success_msg:'',
			// shipping payment start 
			ship_cc_pay:'',
			ship_pre_payment_id:'',
			ship_order_id:'',
			ship_paid_amt:'',
			ship_book_type:'',

			ship_username:'',
			ship_address:'',
			ship_city:'',
			ship_state:'',
			ship_pincode:'',
			ship_mobile:'',
			ship_email:'',
			pageId:'.web_order_details_page',
			// shipping payment ends 
		}
		this.getOrderDetails=this.getOrderDetails.bind(this);
		this.enableOtherAmount=this.enableOtherAmount.bind(this);
		this.validateOtherAmount=this.validateOtherAmount.bind(this);
		this.payNow=this.payNow.bind(this);
		this.ccAvenue=this.ccAvenue.bind(this);
		this.payOtherAmount=this.payOtherAmount.bind(this);
		this.close=this.close.bind(this);
		this.openCancelModal=this.openCancelModal.bind(this);
		this.getCancelDetails=this.getCancelDetails.bind(this);
		this.handleCancel_Submit=this.handleCancel_Submit.bind(this);
		this.selectedReason=this.selectedReason.bind(this);
		this.update_other_reason=this.update_other_reason.bind(this);

		this.shippingPayNow=this.shippingPayNow.bind(this);
		this.shipping_ccAvenue=this.shipping_ccAvenue.bind(this);
	}

	componentDidMount()
	{
	this.props.get_rzp_keys("desktop_web");	
	localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_e_coupon_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('web_mycart');
    localStorage.removeItem('w_r_enq_seller_page');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('web_ofr_page');
    localStorage.removeItem('profile');
    localStorage.removeItem('myaquacash');
    localStorage.removeItem('web_share_earn');
    localStorage.removeItem('checkout');
    
    localStorage.removeItem('myorders');
    localStorage.removeItem('w_r_p_deals');
    localStorage.removeItem('seed');
    localStorage.removeItem('nauplii');
    localStorage.removeItem('subdeals');
    localStorage.removeItem('shipping');
    localStorage.removeItem('notifications');
    localStorage.removeItem('web_quickcart');
    localStorage.removeItem('view_rating');
    localStorage.removeItem('w_modal_seed');
    localStorage.removeItem('w_r_seed_deals');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_modal_details');
    localStorage.removeItem('offers');
    localStorage.removeItem('give_rating');
    localStorage.removeItem('pprice');
    localStorage.removeItem('sprice');
    localStorage.removeItem('seed_id');
    localStorage.removeItem('h_type');
    localStorage.removeItem('web_pro_ofr_dtls');
    localStorage.removeItem('web_wishlist');
    localStorage.removeItem('web_brand_details');

    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_e_coupon_dt');
    localStorage.removeItem('m_r_e_s_dt');
    localStorage.removeItem('mob_mycart');
    localStorage.removeItem('m_r_enq_seller_page');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('m_r_e_p_dt');
    localStorage.removeItem('ofr_page');
    localStorage.removeItem('pro_ofr_dtls');

    localStorage.removeItem('share_earn');
    localStorage.removeItem('my_orders');
    localStorage.removeItem('m_r_p_deals');
    localStorage.removeItem('mob_quickcart');
    localStorage.removeItem('partner_deals');
		if(screen.width < 800)
		{
			window.location.href="/order_details/"+this.props.params.OrderType+'/'+this.props.params.Oid;
		}
		if(!localStorage.user_id /*&& !localStorage.token*/)
		{
			localStorage.setItem('order_details','/web/order_details/'+this.props.params.OrderType+'/'+this.props.params.Oid);
			browserHistory.push('/web/login');
		}
		else
		{
			this.getOrderDetails();
			localStorage.setItem('pay_page','/web/order_details/'+this.props.params.OrderType+'/'+this.props.params.Oid);
		}
	
	}
	shippingPayNow()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,bid:this.props.params.Oid,type:this.props.params.OrderType,details_flag:1}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			url: baseUrl+'ship_payment_temp_process',
			dataType:'json',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						ship_pre_payment_id:data.pre_payment_id,
						ship_order_id:data.order_id,
						ship_paid_amt:data.paid_amt,
						ship_book_type:data.book_type,
						
						ship_username:data.shipaddress[0].name,
						ship_address:data.shipaddress[0].address,
						ship_city:data.shipaddress[0].city,
						ship_state:data.shipaddress[0].state,
						ship_pincode:data.shipaddress[0].zip,
						ship_mobile:data.shipaddress[0].phone,
						ship_email:data.shipaddress[0].email,
					});
					//this.shipping_ccAvenue();
					var payment_params= {from:'desktop_web',
					uid:localStorage.getItem('user_id'),
					pre_payment_id:data.pre_payment_id,
					order_id:data.order_id,
					deal_type:this.state.ship_book_type,
					cart_ids:data.cart_ids,
					paid_amt:data.paid_amt,
					username: this.state.ship_username,
					address:this.state.ship_address,
					city:this.state.ship_city,
					state:this.state.ship_state,
					pincode:this.state.ship_pincode,
					mobile:this.state.ship_mobile,
					country:'India',
					email:this.state.ship_email,
					cart_add_id:'shipping_amt',
					pageId:this.state.pageId,
					rzp_key:this.props.rzp_keys.key_id};					
   if(this.state.gateway_mode == 2){										
	   razorpayForm(payment_params);										
   }else{											
	   ccAvenue(payment_params);
   }

				}
				
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}

		});
	}
	shipping_ccAvenue()
	{
		var username=this.state.ship_username;
		var address=this.state.ship_address
		var city=this.state.ship_city;
		var state=this.state.ship_state;
		var pincode=this.state.ship_pincode;
		var mobile=this.state.ship_mobile;
		var email=this.state.ship_email;
		var shipping_amt ='shipping_amt';
		var deal_type = this.state.ship_book_type;
		
		var basePayUrl='https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
		// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';

		var data1={access_code:'AVIJ67DJ41BD20JIDB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:shipping_amt,merchant_param4:'mobile_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',redirect_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
		// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.ship_order_id,merchant_param1:this.state.ship_pre_payment_id,merchant_param2:deal_type,merchant_param3:shipping_amt,merchant_param4:'desktop_web',amount:this.state.ship_paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};

		$.ajax({
			method:'POST',
			data:data1,
			url:basePayUrl,
			success:function(data)
			{
				$('.web_order_details_page').html(data);
			},
			error:function(err)
			{
				console.log(err);
				alert(err);
			}
		});
	}
	openCancelModal(bid,booking_type)
	{
		this.setState({
			cancel_modal_status:true,
		});
	}
	getCancelDetails()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token}
		var data2=JSON.stringify(data1);

		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'cancel_reasons',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						cancel_reasons:data.reasons,
					});
				}
			}.bind(this),
			error:function(err)
			{
				// console.log(err);
			}
		});
	}
	componentWillMount()
	{
		var that=this;
		setTimeout(function(){
			that.enableDetails();
		},3000);
	}
	close()
	{
		this.setState({
			confirm_modal:false,
			cancel_modal_status:false,
			cancel_success_status:false,
		});
	}
	enableDetails()
	{
		this.setState({
			details_status: true,
		});
	}
	getOrderDetails()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,bid:this.props.params.Oid,order_type:this.props.params.OrderType};
		var data2=JSON.stringify(data1);
		var order_type = this.props.params.OrderType;
		
		this.setState({
			page_loading:true,
		});

		if(order_type==='0')
		{
			var call_fn='Booking_details';
		}
		else if(order_type==='1')
		{
			call_fn='pro_booking_details';
		}
		else
		{
			call_fn='pro_booking_details';	
		}
		
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+call_fn,
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						page_loading:false,
						total_data:data,
						details:data.details,
						shipping_address:data.shipping_address,
						items:data.items,
						applied_coupons:data.applied_coupons,
						payment_details:data.payment_details,
						ship_dlvr_blck:data.ship_dlvr_blck,
						aqua_cash:data.aqua_cash,
						aqua_cash1:data.aqua_cash1,
						seller_discount:data.seller_discount,
						seller_discount1:data.seller_discount1,
						promo_hatch_value:data.promo_hatch_value,
						promo_hatch_value1:data.promo_hatch_value1,
						promo_manf_value:data.promo_manf_value,
						promo_manf_value1:data.promo_manf_value1,
						coupons_amt:data.coupons_amt,
						coupons_amt1:data.coupons_amt1,
						payment_log:data.payment_log,
						shipment_log:data.shipment_log,
						applied_cpns_amt:data.details.applied_cpns_amt,
						pay_now_btn:data.pay_now_btn,
						other_amount_btn:data.other_amount_btn,
						famount_pay_manufacturer:data.famount_pay_manufacturer,
						famount_pay_hatchery:data.famount_pay_hatchery,
						min_val:data.min_val,
						max_val:data.max_val,
						book_id:data.details.booking_id,

						pre_payment_id:'',
						order_id:'',
						paid_amt:'',
						rate_flag:data.rate_flag,
						shipping_details:data.shipping_details,
						confirm_btn_show:data.confirm_btn_show,
						transport_mode:data.transport_mode,

						cancel_time:data.cancel_time,
						cancel_reason:data.cancel_reason,
						cancel_by:data.cancel_by,
						ship_cc_pay:data.ship_cc_pay,
						gateway_mode:data.gateway_mode
					});
				}
				else
				{
					this.setState({
						page_error_status:true,
					});
				}
			}.bind(this),
			error:function(err)
			{
				// console.log(err);
			}
		})
	}
	enableOtherAmount()
	{
		this.setState({
			other_amount_btn_status:true,
		});
	}
	validateOtherAmount()
	{
		this.setState({
			err_qty_status:false,
			err_qty_msg:'',
		});
		//var x='';
		if(parseInt(this.refs.ref_other_amt.value,10) < parseInt(this.state.min_val,10))
		{
			//x='Minimum Quantity is '+this.state.min_val;
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Minimum amount is '+this.state.min_val,
			});
		}
		if(parseInt(this.refs.ref_other_amt.value,10) > parseInt(this.state.max_val,10))
		{
			//x='Maximum Quantity is '+this.state.max_val;
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Maximum amount is '+this.state.max_val,
			});
		}
		const check= /[^0-9]/gi;
		if(check.test(this.refs.ref_other_amt.value))
		{
			//x='* Invalid Amount';	
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Invalid Amount',
			});
		}

		//if(x==='')
		//{
			//this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);	
		//}
	}
	payNow()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		if(this.props.params.OrderType ==='1')
		{
			var paid_amt = this.state.famount_pay_manufacturer;
		}
		else if(this.props.params.OrderType==='0')
		{
			paid_amt = this.state.famount_pay_hatchery;
		}
		
		var pay_type ='1';
		var book_id = this.state.book_id;
		var book_type = this.props.params.OrderType;
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,book_id:book_id,paid_amt:paid_amt,pay_type:pay_type,book_type:book_type}
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+'rem_amt_temp_process',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						pre_payment_id:data.pre_payment_id,
						order_id:data.order_id,
						paid_amt:data.paid_amt,
					});
				}
				//this.ccAvenue();
				var payment_params= {from:'desktop_web',
				uid:localStorage.getItem('user_id'),
				pre_payment_id:data.pre_payment_id,
				order_id:data.order_id,
				deal_type:this.props.params.OrderType,
				cart_ids:'',
				paid_amt:data.paid_amt,
				username: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '',
				address:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '',
				city:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
				state:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '',
				pincode:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '',
				mobile:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '',
				country:'India',
				email:'',
				cart_add_id:'rem_amt',
				pageId:this.state.pageId,
				rzp_key:this.props.rzp_keys.key_id};

				if(this.state.gateway_mode == 2){										
					razorpayForm(payment_params);					
				}else{
					ccAvenue(payment_params);					
				}				
			}.bind(this),
			error:function(err)
			{
				// console.log(err);
			}
		});
	}
	payOtherAmount()
	{
		var x='';
		
		if(this.refs.ref_other_amt.value ==='')
		{
			x='* Enter Amount';
			this.setState({
				err_qty_status:true,
				err_qty_msg:'* Enter Amount',
			});
		}
		if(parseInt(this.refs.ref_other_amt.value,10) === parseInt(this.state.max_val,10))
		{
			this.setState({
				confirm_modal: true,
			});
		}
		
		else
		{
			if(parseInt(this.refs.ref_other_amt.value,10) < parseInt(this.state.min_val,10))
			{
				x='Minimum Quantity is '+this.state.min_val;
				this.setState({
					err_qty_status: true,
					err_qty_msg:'* Minimum amount is '+this.state.min_val,
				});
			}
			if(parseInt(this.refs.ref_other_amt.value,10) > parseInt(this.state.max_val,10))
			{
				// alert('Maximum Quantity is '+this.state.max_qty);
				x='Maximum Quantity is '+this.state.max_val;
				this.setState({
					err_qty_status: true,
					err_qty_msg:'* Maximum amount is '+this.state.max_val,
				});
			}
			const check= /[^0-9]/gi;
			if(check.test(this.refs.ref_other_amt.value))
			{
				x='* Invalid Amount';	
				this.setState({
					err_qty_status: true,
					err_qty_msg:'* Invalid Amount',
				});
			}
			
			if(x==='')
			{
				var baseUrl='https://aquadeals.in/admin/web3/user/';
				var paid_amt = this.refs.ref_other_amt.value;
				var pay_type ='2';
				var book_id = this.state.book_id;
				var book_type = this.props.params.OrderType;
				var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,book_id:book_id,paid_amt:paid_amt,pay_type:pay_type,book_type:book_type}
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'POST',
					dataType:'json',
					url:baseUrl+'rem_amt_temp_process',
					data:{req:data2},
					success:function(data)
					{
						if(data.status==='success')
						{
							this.setState({
								pre_payment_id:data.pre_payment_id,
								order_id:data.order_id,
								paid_amt:data.paid_amt,
							});
						}
						//this.ccAvenue();
						var payment_params= {from:'desktop_web',
						uid:localStorage.getItem('user_id'),
						pre_payment_id:data.pre_payment_id,
						order_id:data.order_id,
						deal_type:this.props.params.OrderType,
						cart_ids:data.cart_ids,
						paid_amt:data.paid_amt,
						username: this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '',
						address:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '',
						city:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '',
						state:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '',
						pincode:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '',
						mobile:this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '',
						country:'India',
						email:'',
						cart_add_id:'rem_amt',
						pageId:this.state.pageId,
						rzp_key:this.props.rzp_keys.key_id};

						if(this.state.gateway_mode == 2){										
							razorpayForm(payment_params);										
						}else{											
							ccAvenue(payment_params);
						}

					}.bind(this),
					error:function(err)
					{
						// console.log(err);
					}
				});
			}
		}
	}
	ccAvenue()
	{
		var username=this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : '';
		var address=this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : '';
		var city=this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : '';
		var state=this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : '';
		var pincode=this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : '';
		var mobile=this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : '';
		var email='';
		var rem_amt ='rem_amt';
		var deal_type = this.props.params.OrderType;
		
		var basePayUrl='https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
	    // var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
		var data1={access_code:'AVIJ67DJ41BD20JIDB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',redirect_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
		// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:rem_amt,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
		$.ajax({
			method:'POST',
			data:data1,
			url:basePayUrl,
			success:function(data)
			{
				$('.web_order_details_page').html(data);
			},
			error:function(err)
			{
				// console.log(err);
			}
		});
	}
	selectedReason(id,flag)
	{
		// var flag=flag;
		if(flag==='1')
		{
			this.setState({
				edit_input_status:true,
				selected_reason:id,
			});
		}
		else
		{
			this.setState({
				edit_input_status:false,
				selected_reason:id,
			})
		}
	}
	update_other_reason(event)
	{
		this.setState({
			edit_input:event.target.value,
		});
	}
	handleCancel_Submit(event)
	{
		event.preventDefault();
		var	bid= this.props.params.Oid;
		var booking_type = this.props.params.OrderType;
		var selected_reason = this.state.selected_reason;
		if(this.state.selected_reason===9)
		{
			selected_reason=this.state.edit_input;
		}
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		if(booking_type==='1')
		{
			var action_url = 'product_booking_cancel';
			var data1={from:'desktop_web',uid:localStorage.user_id,token:localStorage.token,reason:selected_reason,book_id:bid}
			var data2=JSON.stringify(data1);
		}
		else
		{
			action_url = 'booking_cancel';
			data1={from:'desktop_web',uid:localStorage.user_id,token:localStorage.token,book_id:bid,reason:selected_reason}
			data2=JSON.stringify(data1);	
		}

		$.ajax({
			method:'POST',
			dataType:'json',
			url:baseUrl+action_url,
			data:{req:data2},
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						cancel_modal_status:false,
						cancel_success_status:true,
						cancel_success_msg:data.message,
					});
					this.getOrderDetails();
					// alert(data.message);
					// window.location.reload();
				}
				else
				{
					this.setState({
						cancel_modal_status:false,
						cancel_success_status:true,
						cancel_success_msg:data.message,
					});
					this.getOrderDetails();
					// alert(data.message);
					// window.location.reload();
				}
			}.bind(this),
			error:function(err)
			{

			}
		})
	}
	render(){
		document.title=this.state.details.booking_id ? "Order "+this.state.details.booking_id+" Details | AquaDeals" : "Order Details | AquaDeals";
		$('body').css('background-color','#fff');
		var status='';
		if(this.state.details.status==='0' || this.state.details.status==='4' || this.state.details.status==='7')
		{
			status='Order Placed';
		}
		else if(this.state.details.status==='1')
		{
			status='Processing';
		}
		else if(this.state.details.status==='3')
		{
			status='Cancelled';
		}
		else if(this.state.details.status==='5')
		{
			status='Shipping';
		}
		else if(this.state.details.status==='6')
		{
			status='Delivered';
		}
		var order_items='';
		if(this.state.items.length > 0)
		{
			if(this.props.params.OrderType==='1')
			{
				order_items=this.state.items.map(function(order,index){
					return(
						<div className="">
							<div className="order_list_items">
									<div className="col-xs-12 col-md-12 order_subitems">
										<div className="col-xs-3 col-md-3" style={{padding:'0px'}}>
											<i className="Weborder_icon"><img src={order.image} alt="" /></i>
										</div>
										<div className="col-xs-9 col-md-9" style={{padding:'0px'}} >
											{order.title ? <p>{order.title}</p> : <p>&nbsp;</p>}
											{order.brand ? <p><span style={{fontSize:'10px',color:'#999'}}>{order.brand}</span><span style={{float:'right'}}>&#8377; {order.total_amount}</span></p>: <p>&nbsp;</p>}
											{order.mrp || order.quantity ? <p>Price &#8377; {order.mrp} <span>Quantity {order.quantity} </span> </p>:<p>&nbsp;</p>}
										</div>
									</div>
								</div>
						</div>
					);
					})	
			}
			else
			{
				order_items=this.state.items.map(function(order,index){
					return(
						<div className="">
							<div className="order_list_items">
								<div className="col-xs-12 col-md-12 order_subitems">
									<div className="col-xs-2 col-md-2" style={{padding:'0px'}}>
										<i className="seed_order_icon"><img src={order.image} alt="" /></i>
									</div>
									<div className="col-xs-10 col-md-10" style={{padding:'0px'}} >
										{order.specie ? <p style={{color:'#333'}}>{order.specie}</p> : <p>&nbsp;</p>}
										{order.total_amount ? <p><span style={{float:'right'}}>&#8377; {order.total_amount}</span></p> : <p>&nbsp;</p>}
										<p style={{color:'#999'}}><span>Plsize</span>&nbsp;<span>{order.plsize}</span>&nbsp;<span>Salinity</span>&nbsp;<span>{order.salinity}</span></p>
										{/*<p><span>{order.brand}</span><span style={{float:'right'}}>&#8377; {order.total_amount}</span></p>*/}
										{order.mrp || order.quantity ? <p>Price &#8377; {order.mrp} <span>Quantity {order.quantity}</span></p> : <p>&nbsp;</p>}
									</div>
								</div>
							</div>
						</div>
					);
					})		
			}
		}

		var payment_log=this.state.payment_log.map(function(data,index){
			return(
				<div className="ordr_dtls_5"><p>{data.msg}</p></div>
			);
		})
		var shipment_log=this.state.shipment_log.map(function(data,index){
			return(
				<div className="ordr_dtls_5"><p>{data.msg}</p></div>
			);
		})
		var pay_remaining_amount = '';
		if(this.state.pay_now_btn==='yes')
		{
			pay_remaining_amount = <div className="pay_now_btn" onClick={()=>{this.payNow()}}><a>Pay &#8377; {this.state.famount_pay_manufacturer} {this.state.famount_pay_hatchery} Online <i className="fwd_img"><img alt="" src={'https://aquadeals.in/admin/assets/images/fwd_org.png'} width="15px" /></i></a></div>;
		}
		else
		{
			pay_remaining_amount ='';
		}

		var other_amount_btn ='';
		if(this.state.other_amount_btn==='yes')
		{
			other_amount_btn =  <div className="other_amount_btn">
									<a onClick={()=>{this.enableOtherAmount()}}>Pay Other Amount <i className="fwd_img" style={{marginLeft:'11px'}}><img alt="" src={'https://aquadeals.in/admin/assets/images/fwd_org.png'} width="15px" /></i></a>
									{this.state.other_amount_btn_status ? <span className="ordr_dtls_6"><input onChange={()=>this.validateOtherAmount()} ref="ref_other_amt" id="ref_other_amt" type="text" placeholder="Enter Amount" />{this.state.err_qty_status ? <span className="error_other_amt">{this.state.err_qty_msg}</span>: ''}</span> : ''}
									{this.state.other_amount_btn_status ? <a className="pay_other_btn" onClick={()=>{this.payOtherAmount()}}>PAY</a> : ''}
								</div>;
		}
		else
		{
			other_amount_btn='';
		}
		var cancel_reasons = this.state.cancel_reasons.map(function(data,index){
			return(
				<div>
					<input type="radio" id={data.id} name={'reason'} className="cancel_radio" onClick={()=>{this.selectedReason(data.id,data.flag)}} />
					<span>{data.reason}</span>
					{data.flag==='1' ? <div className="other_reason_blk">{this.state.edit_input_status ? <input type="text" name="other_reason" ref="other_reason" id="other_reason" placeholder="Enter any reason" value={this.state.edit_input} onChange={this.update_other_reason} /> :''}</div> : ''}
				</div>
			);
		}.bind(this));


		var cancel_btn_status = this.state.details.status ? this.state.details.status : '';
		var cancel_btn ='';
		if(cancel_btn_status)
		{
			if(cancel_btn_status==="0" || cancel_btn_status==="4" || cancel_btn_status==="7")
			{
				cancel_btn =<div className="web_ordr_ftr_blk" onClick={()=>{this.openCancelModal()}} ><a className="web_ordr_cncl_btn">CANCEL ORDER</a></div>;
			}
			else
			{
				cancel_btn = '';
			}
		}
		
		var transport_info ='';
		if(this.state.details.driver_name !=='' && this.state.details.mobile!=='')
		{
			
			transport_info=<div className="transport_info_blk">
								<h5>Transport Info</h5>
								<div>
									<p><span>{this.state.transport_mode==='0' ? 'Driver Name' : 'Transport Area' } : </span> {this.state.details ? this.state.details.driver_name : ''}</p>
									<p><span>{this.state.transport_mode==='0' ?  'Vehicle No' :'Transport Name'} : </span>{this.state.details ? this.state.details.vehicle_no : ''}</p>
									<p><a href={this.state.details ? 'tel:+'+this.state.details.driver_mobile : ''}>{this.state.details ? this.state.details.driver_mobile : ''}</a></p>
									<p><a href={this.state.details ? 'tel+'+this.state.details.alternate_number_driver : ''}>{this.state.details ? this.state.details.alternate_number_driver : ''}</a></p>
								</div>
							</div>;
			// }
			// else
			// {
			// 	transport_info =<div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div></div>;
			// }
		}
		else
		{
			// transport_info = <div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div><div className="clr">&nbsp;</div></div>;
			transport_info = <div><div className="clr">&nbsp;</div></div>;
		}


       	return(
       	  <div>	
       		<div className="web_deals web_order_details_page">
			    <WebHeaderInner />
		        <div className="clr">&nbsp;</div>
		        <div className="clr">&nbsp;</div>
		        <div className="clr">&nbsp;</div>
		        <div className="clr">&nbsp;</div>
		        <div className="clr">&nbsp;</div>
		        <div className="clr">&nbsp;</div>
		        <div className="clr">&nbsp;</div>
		        <section className="container">
					<div className="row">
						<div className="col-md-12  webDels_cntnt">
							<div className="">
								{this.state.page_error_status ? <Web_NotFound /> :
							<div>
							{!this.state.page_loading ? 
							<div className="ordr_details_content">
								<div className="container-fluid" style={{marginTop:'25px'}}>
									<h5><Link to={'/web/myorders'}><i style={{marginRight:'15px'}}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} width="16px" alt=""/></i></Link>Order {this.state.details.booking_id} Details </h5>
									<a href="/web/home" title="Home" className="web_home_icon1"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/home2.png'} alt="Home" /></a>
							    </div>
								<section className="ordr_dtls_1">
									<div>
										<p><span>{this.state.details.booking_id}</span><span className="right_side">&#8377; {this.state.details.total_discount}</span></p>
										<p><span style={{fontSize:'10px'}}>{this.state.details.book_date}</span><span className="order_details_status">{status}</span></p>
									</div>
								</section>
								<div className="ordr_dtls_2">
									{this.state.items.length > 1 ? <p>You have {this.state.items.length} items in your order</p> : <p>You have {this.state.items.length} item in your order</p> }
									{order_items}
									{this.state.total_data.progress_bar !="" ? 
										<div className="col-md-12 col-sm-12 col-xs-12 Web_order_progress-bar">
											<i><img src={'https://aquadeals.in/admin/assets/images/product_imgs/'+this.state.total_data.progress_bar} alt="" /></i>
										</div>
									: ''}
								</div>
								<div className="" style={{marginTop:'10px'}}>
									<h5 className="ordr_header">ORDER SUMMARY</h5>
									{/*{this.state.details_status ? */}
										<div className="ordr_dtls_3">
											<table className="table cart_table">
												<tr className="cart_tr_total">
													<td>Order Total</td>
													<td>&#8377; {this.state.details.total_amount}</td>
												</tr>
												{this.state.aqua_cash1 && parseInt(this.state.aqua_cash1,10) > 0 ? 
												<tr className="cart_tr">
													<td>Aquacash Discount</td>
													<td>(-) &#8377; {this.state.aqua_cash}</td>
												</tr> : ''}
												{this.state.coupons_amt1 && parseInt(this.state.coupons_amt1,10) > 0 ? 
												<tr className="cart_tr">
													<td>Applicable Coupons</td>
													<td>(-) &#8377; {this.state.coupons_amt}</td>
												</tr> : ''}
												{this.state.seller_discount1 && parseInt(this.state.seller_discount1,10) > 0 ? 
													<tr className="cart_tr">
														<td>Seller Discount</td>
														<td>(-) &#8377; {this.state.seller_discount}</td>
													</tr>
													: ''}
												{this.state.promo_manf_value1 && parseInt(this.state.promo_manf_value1,10) > 0 ?
													<tr className="cart_tr">
														<td>Promo Discount</td>
														<td>(-) &#8377; {this.state.promo_manf_value}</td>
													</tr>
												 : ''}
												 {this.state.promo_hatch_value1 && parseInt(this.state.promo_hatch_value1,10) > 0 ?
													<tr className="cart_tr">
														<td>Promo Discount</td>
														<td>(-) &#8377; {this.state.promo_hatch_value}</td>
													</tr>
												 : ''}
												<tr className="cart_tr_grandtotal">
													<td>&nbsp;</td>
													<td>Total &nbsp; &nbsp; &#8377; {this.state.details.total_discount}</td>
												</tr>
											</table>
										{/*</div> : ''}*/}
										</div>
										</div>
										{this.state.payment_details.length > 0 ? <div style={{marginTop:'10px'}}>
											<h5 className="ordr_header">PAYMENT DETAILS</h5>
												{this.state.payment_details.map(function(item,index){
													return(
														<h5 className="ordr_dtls_4"><span>{item.title}</span><span style={{float:'right'}}>&#8377; {item.value}</span></h5>
													);
												})}
										</div> : ''}

										{payment_log.length > 0 ? 
											<div><h5 className="ordr_header">PAYMENT HISTORY</h5>
												{payment_log}
											</div> : ''}
										{pay_remaining_amount ? <div className="payment_options">
											{pay_remaining_amount}
										</div> : ''}
										{other_amount_btn ? other_amount_btn : ''}					
										<div>
											<h5 className="ordr_header">SHIPPING AND DELIVERY</h5>
											<div>
												{this.state.ship_dlvr_blck.map(function(data,index){
													return(
														<div className="ship_del_blk">
															<h5><span>{data.shipment_charge ? 'Shipping Charge' : ''}</span>{this.state.ship_cc_pay===1 ? <span className="ship_pay_now_btn" onClick={()=>{this.shippingPayNow()}}>{data.shipment_charge ? data.shipment_charge : ''}</span> : <span className="right_side">{data.shipment_charge ? data.shipment_charge : ''}</span>}</h5>
															<h5><span>{data.deliver_date ? 'Delivery Date' : ''}</span><span className="right_side">{data.deliver_date ? data.deliver_date : ''}</span></h5>
														</div>
													);
												}.bind(this))}
											</div>
										</div>
										{shipment_log.length > 0 ? 
											<div><h5 className="ordr_header">SHIPPING PAYMENT HISTORY</h5>
												{shipment_log}
											</div> : ''}										
										<div className="ship_adrs_blk">
											<h5 className="ordr_header">SHIPPING ADDRESS</h5>
											<div>
												<p>{this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].name : ''}</p>
												<p>{this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].address : ''}</p>
												<p>{this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].city : ''} , {this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].state : ''}</p>
												<p>{this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].zip : ''}</p>
												<p style={{color:'#ff742a'}}><a href={this.state.total_data.shipping_address ? 'tel:+'+this.state.total_data.shipping_address[0].mobile : ''}>{this.state.total_data.shipping_address ? this.state.total_data.shipping_address[0].mobile : ''}</a></p>
											</div>
										</div>
										{transport_info}
										{this.state.cancel_by !=='' ? <div>
											<h5 className="ordr_header">CANCELLATION DETAILS</h5>
											<div style={{padding:'10px'}}>
											{this.state.cancel_by ? <p><span>Cancelled by </span><span style={{float:'right'}}>{this.state.cancel_by}</span></p> : ''}
											{this.state.cancel_time ? <p><span>Date & Time </span><span style={{float:'right'}}>{this.state.cancel_time}</span></p> : ''}
											{this.state.cancel_reason ? <p><span>Reason</span><span style={{float:'right'}}>{this.state.cancel_reason}</span></p> : ''}
											</div>
										</div> : ''}
										
								

										<Modal className="order_confirm_modal" show={this.state.confirm_modal} onHide={this.close}  >
											<Modal.Header closeButton>
							    			</Modal.Header>
											<Modal.Body>
									  			<h4 className="order_confirm_title">Are You Sure?</h4>
									  			<p>You are paying full amount !</p>
									  		</Modal.Body>
									  		<Modal.Footer className="modal_footer">
									  			<a onClick={()=>{this.payNow()}}><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>Yes, I will pay</Button></a>
									  		</Modal.Footer>
										</Modal>

										{this.state.details.status === '2' || this.state.details.status ==='6' ? <div className="web_ordr_ftr_blk">{this.state.rate_flag===2 ? <Link className="ordr_view_rate_btn" to={this.props.params.OrderType==='1' ? '/web/viewrating/product/'+this.props.params.Oid : '/web/viewrating/'+this.props.params.Oid}>View Rating</Link> : ''}
										{this.state.rate_flag===1 ? <Link className="ordr_give_rate_btn" to={this.props.params.OrderType==='1' ? '/web/giverating/product/'+this.props.params.Oid : '/web/giverating/'+this.props.params.Oid}>Give Rating</Link> : ''}
										</div> : ''}
										{/*{this.state.confirm_btn_show === 0 ? <div className="web_ordr_ftr_blk"><a>CONFIRM ORDER</a></div> : ''}*/}
										
										{/*{this.state.details.status === '5' ? <div className="web_ordr_ftr_blk"><a>DELIVERED</a></div> : ''}*/}
										{cancel_btn}
										
										<Modal onEntered={()=>{this.getCancelDetails()}}  className="" show={this.state.cancel_modal_status} onHide={this.close} >
											<Modal.Header className="modal_offer_header" closeButton>
									    		<Modal.Title className="m_title" style={{textAlign:'center',color:'#fff'}}>Order Cancellation</Modal.Title>
									  		</Modal.Header>
									  		<Modal.Body>
									  			<div>
									  				<p>Do you want to cancel this Order?</p>
									  				{/*{this.state.processing ? <i><img src={""} /></i>} */}
									  				<form className="cancel_reasons_form" onSubmit={this.handleCancel_Submit}>
									  					<div className="">
										  					{cancel_reasons}
									  					</div>
									  					<div>
									  						<div className="modal-footer">
											  					<a className="cancel_no_btn" onClick={this.close}>No</a>
											  					<button type="submit" className="cancel_yes_btn">Yes</button>
											  				</div>
											  			</div>
									  				</form>
									  			</div>
									  		</Modal.Body>
									  	</Modal>
									  	<Modal className="showModal" show={this.state.cancel_success_status} onHide={this.close}  >
											<Modal.Body>
								          		<h4 style={{fontSize:'14px', color:'#666',textAlign:'center'}}>{this.state.cancel_success_msg}</h4>
								        	</Modal.Body>
								        </Modal>
									</div> : <div className="page_loading"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  /></div>}
								</div>}							
									</div>
								</div>
							</div>
						</section>
			  </div>
            <WebFooter />
          </div>     
		
		);
	}
}

function mapStateToProps(state){
    return {
 		rzp_keys: state.posts.rzp_keys
    }
}
export default connect(mapStateToProps,actions)(Web_Order_Details);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Orders/Web_Order_Details.js
 **/